import React, { useState, useEffect } from 'react';
import { useConnectivity } from '../contexts/ConnectivityContext';
import { Snackbar, Alert, Box, Paper, Typography, Button } from '@mui/material';
import WifiOffIcon from '@mui/icons-material/WifiOff';
import RefreshIcon from '@mui/icons-material/Refresh';

const OfflineAlert = () => {
  const { isOnline, checkServerConnectivity, showOfflineAlert, setShowOfflineAlert } = useConnectivity();
  
  const handleRefresh = async () => {
    const isConnected = await checkServerConnectivity();
    if (isConnected) {
      setShowOfflineAlert(false);
    }
  };

  // For users who are already logged in, show a more prominent alert
  if (showOfflineAlert && !isOnline) {
    return (
      <Box
        sx={{
          position: 'fixed',
          bottom: 16,
          right: 16,
          zIndex: 2000,
        }}
      >
        <Paper
          sx={{
            p: 2,
            backgroundColor: 'error.main',
            color: 'error.contrastText',
            display: 'flex',
            alignItems: 'center',
            gap: 2
          }}
        >
          <WifiOffIcon />
          <Typography>You're offline. Some features may be unavailable.</Typography>
          <Button
            variant="contained"
            size="small"
            color="inherit"
            startIcon={<RefreshIcon />}
            onClick={handleRefresh}
            sx={{ ml: 2 }}
          >
            Reconnect
          </Button>
        </Paper>
      </Box>
    );
  }

  // For transient notifications
  return (
    <Snackbar 
      open={!isOnline} 
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
    >
      <Alert 
        severity="error" 
        icon={<WifiOffIcon />}
        action={
          <Button 
            color="inherit" 
            size="small" 
            onClick={handleRefresh}
          >
            Retry
          </Button>
        }
      >
        Internet connection is unavailable
      </Alert>
    </Snackbar>
  );
};

export default OfflineAlert; 